import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { FaCircleArrowRight } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { FaCalendarCheck, FaDollarSign, FaCut, FaUsers } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import en from "../../language/En";
import ar from "../../language/Ar";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SalonTable from "./SalonTable";
import { fetchAdminStats, fetchDashGraph } from "../../redux/adminReducer";
import Loader from "../../common/loader";
function Home() {
  const { lang, translations } = useSelector((state) => state.language);
  const isRTL = document?.body?.dir === "rtl";
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const adminStats = useSelector((state) => state.admin.stats?.data || []);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleYearChange = (e) => {
    const newYear = parseInt(e.target.value);
    setSelectedYear(newYear);
    dispatch(fetchDashGraph(newYear)); // Fetch graph data for selected year
  };

  const graphStats = useSelector((state) => state.admin.graphStats?.data || []);
  useEffect(() => {
    setLoading(true);
    dispatch(fetchDashGraph(selectedYear));
    dispatch(fetchAdminStats()).then(() => {
      setLoading(false);
    });
  }, [dispatch, selectedYear]);
  console.log(adminStats);
  const earningsData = graphStats?.earningsData || [];

  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="min-h-screen w-full  px-4 py-4">
            <section className="pt-1">
              <h1 className="text-xl font-bold text-white">
                {translations.dashboard.dashboard}{" "}
                <small className="text-2xl text-gray-600 font-semibold">
                  {" "}
                  |
                </small>
                <small className="font-normal text-gray-600">
                  {" "}
                  {translations.dashboard.systemOverview}
                </small>
              </h1>
            </section>

            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
              {/* Total Bookings */}
              <div className=" grid bg-gray-800 shadow-xl rounded p-4 text-white  items-center gap-4">
                <div className="bg-green-500 w-10 h-10 flex items-center justify-center rounded-full">
                  <FaCalendarCheck className="text-white text-lg" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold">
                    {adminStats?.totalBookings || 0}
                  </h3>
                  <p>{translations.dashboard.totalBookings}</p>
                </div>
              </div>

              {/* Total Earnings */}
              <div className="grid bg-gray-800 shadow-xl rounded p-4 text-white  items-center gap-4">
                <div className="bg-yellow-500 w-10 h-10 flex items-center justify-center rounded-full">
                  <FaDollarSign className="text-white text-lg" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold">
                    SAR {adminStats?.totalEarnings || 0}
                  </h3>
                  <p>{translations.dashboard.totalEarnings}</p>
                </div>
              </div>

              {/* Salons */}
              <div className=" grid bg-gray-800 shadow-xl rounded p-4 text-white  items-center gap-4">
                <div className="bg-purple-500 w-10 h-10 flex items-center justify-center rounded-full">
                  <FaCut className="text-white text-lg" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold">
                    {adminStats?.totalSalons || 0}
                  </h3>
                  <p>{translations.dashboard.salons}</p>
                </div>
              </div>

              {/* Total Customers */}
              <div className="grid bg-gray-800 shadow-xl rounded p-4 text-white  items-center gap-4">
                <div className="bg-blue-500 w-10 h-10 flex items-center justify-center rounded-full">
                  <FaUsers className="text-white text-lg" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold">
                    {adminStats?.totalUsers || 0}
                  </h3>
                  <p>{translations.dashboard.totalCustomers}</p>
                </div>
              </div>
            </div>

            {/* Graph + Table */}
            <div className=" mt-5  ">
              {/* Earnings Chart */}
              <div className="bg-gray-800 shadow-xl text-white rounded">
                <div className="flex justify-between px-4 pt-4 text-lg">
                  <p className="text-white">
                    {translations.dashboard.earnings}
                  </p>
                  <div className="flex items-center gap-4">
                    <select
                      value={selectedYear}
                      onChange={handleYearChange}
                      className="bg-gray-700 text-white rounded-md px-3 py-1 text-sm border border-gray-600 hover:border-purple-500 focus:outline-none focus:ring-1 focus:ring-purple-500"
                    >
                      {[currentYear, currentYear - 1, currentYear - 2].map(
                        (year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        )
                      )}
                    </select>
                    <p className="text-white">
                      {translations.dashboard.allPayments}
                    </p>
                  </div>
                </div>
                <hr className="" />
                <div className="flex justify-between items-center px-4 ">
                  <div>
                    <p className="font-bold text-lg mb-0">
                      SAR {graphStats?.totalEarnings}
                    </p>
                    <p className="text-md text-gray-600">
                      {translations.dashboard.earningOverTime}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-semibold mb-0">
                      {graphStats?.totalBookings}
                    </p>
                    <p className="text-md text-gray-600">
                      {translations.dashboard.totalBookings}
                    </p>
                  </div>
                </div>
                <div className="w-full h-[380px] px-3 ">
                  <ResponsiveContainer width="100%" height={420}>
                    <BarChart
                      data={earningsData}
                      barCategoryGap="15%"
                      barGap={5}
                      margin={{
                        top: 20,
                        right: isRTL ? 40 : 20,
                        left: isRTL ? 20 : 40,
                        bottom: 70,
                      }}
                    >
                      <XAxis
                        dataKey="month"
                        axisLine={false}
                        tickMargin={10}
                        width={70}
                        tick={{ fill: "gray", fontSize: 12 }}
                      />
                      <YAxis
                        axisLine={false}
                        tick={{ fill: "gray", fontSize: 14 }}
                        width={lang ? 30 : 40}
                        tickMargin={lang ? 35 : -40}
                      />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "#2A173A", // your dark tooltip color
                          border: "1px solid #5A189A",
                          color: "#fff",
                        }}
                        cursor={{ fill: "transparent" }} // 🔥 This line disables the hover bar background
                      />
                      <Legend wrapperStyle={{ bottom: 70, left: 10 }} />
                      <Bar
                        dataKey="earnings"
                        fill="#5A189A"
                        barSize={30}
                        // name={`Year - ${graphStats?.year}`}
                        activeBar={{
                          fill: "#5A189A", // same fill to maintain color
                          stroke: "#C084FC", // border color on hover (customize this)
                          strokeWidth: 3,
                          radius: [4, 4, 0, 0], // optional: rounded top corners
                        }}
                      >
                        <LabelList
                          dataKey="earnings"
                          position="top"
                          style={{ fill: "#fff", fontSize: 12 }} // White text, adjust as needed
                        />
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>

              {/* Salons Table */}
              {/* <div className="bg-gray-800 shadow-xl rounded">
            <div className="flex justify-between px-4 pt-4 text-lg">
              <p className="text-white">{translations.dashboard.salons}</p>
              <Link to="/salon-list" className="text-white cursor-pointer"><GiHamburgerMenu /></Link>
              
            </div>
            <hr  className="border-t border-gray-300 "/>
            <div className="overflow-x-auto pb-0 mb-0">
             
              <SalonTable/>
            </div>
          </div> */}
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}

export default Home;
